import * as React from 'react';

import {TruncateHitAreaConfigurationContext, frameworkTruncateHitArea} from './truncateHitAreaConfiguration';

const withTruncateHitAreaConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <TruncateHitAreaConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...frameworkTruncateHitArea}/>
                );
            }}
        </TruncateHitAreaConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withTruncateHitAreaConfiguration;